import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../../App';
const ShowNav = () => {
    const context = useContext(AuthContext)
    useEffect(() => {
        context.authDispatch('true')

    }, [])
    return (<></>);
}

export default ShowNav;